export default "__VITE_ASSET__kJJA7d8U__"